import React from 'react';
import { GradientButton } from '../GradientButton/GradientButton';
import styles from './ConfirmationModal.module.scss';
import { Modal } from 'antd';
import { DiscardChangesBgIcon } from '../../assets';

const ConfirmationModal = ({
  open,
  setOpen,
  title = 'Unsaved Changes',
  content = 'Are you sure you want to discard the changes?',
  cancelText = 'Cancel',
  confirmText = 'Yes',
  onCancel,
  onConfirm,
  bgIcon = <DiscardChangesBgIcon/>
}) => {
  return (
    <div className={styles.confirmModalContainer}>
      <Modal
        visible={open}
        closable={false}
        footer={null}
        getContainer={false}
        className={styles.confirmModal}
      >
        <div className={styles.bgIconContainer}>{bgIcon}</div>
        <div className={styles.confirmationBody}>
          <span className={styles.header}>{title}</span>
          <span className={styles.content}>{content}</span>
          <div className={styles.actionButtonContainer}>
            <GradientButton
              variant="outline"
              type="primary"
              onClick={onCancel}
              className={styles.actionButton}
            >
              {cancelText}
            </GradientButton>
            <GradientButton
              type="primary"
              className={styles.actionButton}
              htmlType="submit"
              onClick={onConfirm}
            >
              {confirmText}
            </GradientButton>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ConfirmationModal;
